import * as React from 'react';
import { useNavigate } from 'react-router-dom';

const Modalpopup = ({ buttonText }) => {
	const navigate = useNavigate();

	return (
		<div
			className='Modalpopup text-medium m-2 mt-7 block cursor-pointer rounded-3xl bg-gradient-to-b from-white/50 to-white/10 px-11 py-[12px] text-center text-base text-white hover:bg-gradient-to-b hover:from-white/40 hover:to-white/5'
			onClick={() => navigate('/pricing')}
		>
			{buttonText}
		</div>
	);
};

export default Modalpopup;
